import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { ReactComponent as LoadingIcon } from 'assets/icons/tail-spin.svg';
import { useIntl } from 'react-intl';
import { commonMessages } from 'utils/commonMessages';


export const LoadingPage = () => {
  const { formatMessage } = useIntl();
  const [displayLoading, setDisplayLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setDisplayLoading(true);
    }, 1000);
  }, []);

  return (
    <>
      {displayLoading && (
        <Stack justifyContent='center' color='grey.400' alignItems='center' flexGrow={1} gap={6}>
          <LoadingIcon style={{ maxWidth: '200px' }} />
          <Typography variant='h4'>{formatMessage(commonMessages.loading)}</Typography>
        </Stack>
      )}
    </>
  );
};